<template>
  <div
    @mouseover="show"
    @mouseleave="hide"
    class="flex items-center relative"
  >
    <div ref="parent">
      <slot name="default"></slot>
    </div>
    <teleport to="body">
      <div
        ref="menu"
        class="pr-4 fixed font-semibold z-50 p-2 text-xs text-white bg-gray-600 rounded-sm shadow-lg w-fit max-w-64"
        v-if="isVisible"
        :style="popoverMenu.popoverMenuStyle"
      >
        <slot name="content">
          {{ content }}
        </slot>
      </div>
    </teleport>
  </div>
</template>

<script>
  import usePopoverMenu from '@/composables/usePopoverMenu.js';

  export default {
    props: {
      content: {
        type: String,
        required: false
      }
    },
    computed: {
      isVisible() {
        return this.showTooltip && (this.content || this.$slots.content);
      }
    },
    data() {
      return {
        showTooltip: false,
        top: 0,
        left: 0,
        popoverMenu: usePopoverMenu()
      };
    },
    methods: {
      show() {
        if (!this.showTooltip) {
          this.popoverMenu.calculatePosition(this.$refs.parent, this.$refs.menu, {
            marginX: -10
          });
        }

        this.showTooltip = true;
      },
      hide() {
        this.showTooltip = false;
      }
    }
  };
</script>

<style scoped>
  /* Add any additional styling here if needed */
</style>
